module.exports = __webpack_public_path__ + "static/modal-66990e86061bab7007bb1a397465a6e0.jpg";